import axios from 'axios';

export interface RegisterRequest {
  companyName: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phone?: string;
  companyAddress?: string;
  companyAddressNr?: string;
  companyZipCode?: string;
  companyCity?: string;
  startTrial?: boolean;
}

export interface RegisterResponse {
  Success: boolean;
  Message: string;
  RevolutSubscriptionId?: string;
  PaymentUrl?: string;
}

export async function register(data: RegisterRequest): Promise<RegisterResponse> {
  const res = await axios.post<RegisterResponse>('/api/Registration/Register', data);
  return res.data;
}

export async function resendActivation(email: string): Promise<{ message: string }> {
  const res = await axios.post<{ message: string }>('/api/Registration/ResendActivation', { email });
  return res.data;
}

export async function startPayment(email: string): Promise<RegisterResponse> {
  const res = await axios.post<RegisterResponse>('/api/Registration/StartPayment', { email });
  return res.data;
}
